























import { Component, Vue, Prop, Emit } from 'vue-property-decorator'
import { QueryHouseByCode, UpdateHouseInfo } from '@/api'
import { Message } from 'element-ui'
import { ElForm } from 'element-ui/types/form'
import Rules from '@/utils/rules'

@Component({
  components: {},
})
export default class UpdateHouseDialog extends Vue {
  private show = false
  private data = {}
  private requiredRule = { required: true, message: '不能为空', trigger: 'blur' }
  private rules = {
    communityName: [this.requiredRule],
    houseAccount: [this.requiredRule],
    reservedMobilePhone: [this.requiredRule, Rules.isMobile],
  }

  @Emit('close')
  private close() {
    (this.$refs.form as ElForm).resetFields()
    this.show = false
  }
  public async open(houseCode: string) {
    this.show = true
    this.data = {}
     if(houseCode){
      const result = await QueryHouseByCode({houseCode});
      this.data = result
     }
  }

  public async save() {
    (this.$refs.form as ElForm).validate(async (success: boolean) => {
      if (!success) {
        return
      }
      await UpdateHouseInfo(this.data)
      Message.success('保存')
      this.close()
    })
  }
}
